const ACCESS_TOKEN_KEY = "access_token";
const REFRESH_TOKEN_KEY = "refresh_token";
// Appeal state for suspended / blocked users (see routes/_auth/account-suspended).
const APPEAL_TOKEN_KEY = "appeal_token";
const APPEAL_SENT_AT_KEY = "appeal_sent_at";

function safeStorage(): Storage | null {
  if (typeof window === "undefined") return null;
  try {
    const ls = window.localStorage;
    if (!ls) return null;
    return ls;
  } catch {
    return null;
  }
}

function isValidToken(value: string | null): value is string {
  if (!value) return false;
  const trimmed = value.trim();
  if (trimmed === "" || trimmed === "null" || trimmed === "undefined") {
    return false;
  }
  return true;
}

export function getToken(): string | null {
  const ls = safeStorage();
  if (!ls) return null;
  try {
    const v = ls.getItem(ACCESS_TOKEN_KEY);
    return isValidToken(v) ? v : null;
  } catch {
    return null;
  }
}

export function getRefreshToken(): string | null {
  const ls = safeStorage();
  if (!ls) return null;
  try {
    const v = ls.getItem(REFRESH_TOKEN_KEY);
    return isValidToken(v) ? v : null;
  } catch {
    return null;
  }
}

export function setTokens(accessToken: string, refreshToken: string): void {
  const ls = safeStorage();
  if (!ls) return;
  if (!isValidToken(accessToken) || !isValidToken(refreshToken)) return;
  try {
    ls.setItem(ACCESS_TOKEN_KEY, accessToken);
    ls.setItem(REFRESH_TOKEN_KEY, refreshToken);
    // A working session means the account isn't suspended (any more).
    ls.removeItem(APPEAL_TOKEN_KEY);
    ls.removeItem(APPEAL_SENT_AT_KEY);
  } catch {
    // ignore quota / private-mode failures
  }
}

export function clearTokens(): void {
  const ls = safeStorage();
  if (!ls) return;
  try {
    ls.removeItem(ACCESS_TOKEN_KEY);
    ls.removeItem(REFRESH_TOKEN_KEY);
  } catch {
    // ignore
  }
}

function readKey(key: string): string | null {
  const ls = safeStorage();
  if (!ls) return null;
  try {
    return ls.getItem(key);
  } catch {
    return null;
  }
}

function writeKey(key: string, value: string): void {
  const ls = safeStorage();
  if (!ls) return;
  try {
    ls.setItem(key, value);
  } catch {
    // ignore
  }
}

/** Token sent with "account_suspended"; identifies the account to the appeal form. */
export function getAppealToken(): string | null {
  const v = readKey(APPEAL_TOKEN_KEY);
  return isValidToken(v) ? v : null;
}

export function setAppealToken(token: string): void {
  if (isValidToken(token)) writeKey(APPEAL_TOKEN_KEY, token);
}

/** When this browser last sent an appeal (ISO string), if ever. */
export function getAppealSentAt(): string | null {
  return readKey(APPEAL_SENT_AT_KEY);
}

export function setAppealSentAt(iso: string): void {
  writeKey(APPEAL_SENT_AT_KEY, iso);
}
